import moment from 'moment';
import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Alert, Tooltip, Card} from 'antd';
import {ColumnProps} from 'antd/lib/table';

import {Payment, History} from '../interfaces';
import {GET_PAYMENTS} from '../graphql';
import PaymentHistory from './PaymentHistory';

interface Properties {
  regionId: string;
}

class PaymentHistoryWrapper extends Component<Properties> {
  render() {
    const {regionId} = this.props;
    return (
      <Query query={GET_PAYMENTS} variables={{regionId, first: 10}} notifyOnNetworkStatusChange>
        {({loading, refetch, error, data: {payments, clubs}}: any) => {
          if (error) {
            return `Error! ${error.message}`;
          }
          const columns: Array<ColumnProps<Payment>> = [
            {
              title: 'Date',
              key: 'date',
              render: (payment: Payment) => {
                const date: Date = Number(payment.createdAt) ? new Date(Number(payment.createdAt)) : new Date(payment.createdAt);
                return (
                  <Tooltip title={moment(date).format('HH:mm:ss')}>
                    <span>{moment(date).format('YYYY-MM-DD')}</span>
                  </Tooltip>
                );
              },
            },
            {
              title: 'Type',
              dataIndex: 'type',
              key: 'type',
            },
            {
              title: 'Payed',
              key: 'processed',
              render: (payment: Payment) => (payment.processed ? <div style={{backgroundColor: '#90ee90'}}>Yes</div> : <div style={{backgroundColor: '#ffcccb'}}>No</div>),
            },
            {
              title: 'Reference',
              dataIndex: 'reference',
              key: 'reference',
            },
            {
              title: 'Member ID',
              dataIndex: 'memberPK',
              key: 'memberPK',
            },
            {
              title: 'Amount',
              dataIndex: 'amount',
              key: 'amount',
            },
            {
              title: 'Currency',
              dataIndex: 'currency',
              key: 'currency',
            },
            {
              title: 'Error',
              key: 'error',
              render: ({history}: Payment) =>
                history.some(({type}: History) => type === 'error') ? <Alert message="There is some error in this order" type="error" showIcon style={{width: 270}} /> : '-',
            },
          ];
          return (
            <PaymentHistory
              columns={columns}
              paymentData={payments ? payments.payments : []}
              totalPages={payments ? payments.totalCount : 0}
              refetch={refetch}
              regionId={regionId}
              loading={loading}
              clubs={clubs || []}
            />
          );
        }}
      </Query>
    );
  }
}

export default PaymentHistoryWrapper;



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/components/PaymentHistoryWrapper.tsx